export default __webpack_public_path__ + "static/bunker-web-1-mobile-94ae86c0443b04c2b63bf6c4231a433b.jpg";